







































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class BtnStockSchedule extends Vue {
  @Prop({ default: null }) public commodity: Common.Commodity;
  @Prop({ default: null }) public sku: Common.SKU;  
  @Prop({ default: null }) public segment: Common.Segment;  
  @Prop({ default: false }) public value: boolean;  
  @Prop({ default: null }) public target: HTMLElement;  
  @Prop({ default: 'top' }) public placement: string;  
  @Prop({ default: false }) public requireSku: boolean;  
  @Prop({ default: null }) public stockDate: Date;  //間接的にclosingDateにバインド

  public backSalesOrder: number = 0;
  public backPurchaseOrder:number = 0;
//   public target: HTMLElement = null;
 public showPopover:boolean = false;
  public isLoading:boolean = true;
  public closingDate : Date = null;
  public items = new Array();
　public get popover_title(){
    return this.closingDate? '在庫詳細 (基準日)':'在庫詳細';
  }

  public get message() {
    if (this.requireSku && (this.commodity ==null || this.sku == null)) return '対象SKUを選択してください';
    else if (this.requireSku == false && this.commodity == null) return '対象商品を選択してください';
    else if (this.commodity && this.commodity.isNoStock) return '棚卸対象商品を選択してください';
    else return null;
  }

  @Watch('value')  
  public onShowChanged(newValue:boolean, oldValue:boolean){        
    if (newValue) {
      this.closingDate = this.stockDate ? this.stockDate : new Date(); //closingDateをセットすると自動でデータロードされる     
      // this.loadList();
    } else {
    (this.$refs.panel as  HTMLElement).removeEventListener('focusout', this.closePopup);      
    }
  }

  public loadList(){
      this.isLoading = true;
      var query = new Common.CommodityScheduleQuery2(this.closingDate,this.commodity.code,this.sku ? this.sku.code: null);
      query.segmentId = this.segment ? this.segment.id : null
      this.$api.execute(query).then(res => {
        var obj = res as Common.CommoditySchedule;
        this.backSalesOrder = obj.salesOrderBacklog;
        this.backPurchaseOrder = obj.purchaseOrderBacklog;
        this.items = obj.items;
        this.isLoading = false;
      });   
  }

  public onClick(flag:string){
    var targetDate = new Date(this.closingDate);
    if (flag == 'left-rapid') targetDate.setDate(targetDate.getDate() -7);
    else if (flag == 'left') targetDate.setDate(targetDate.getDate() -1);    
    else if (flag == 'right') targetDate.setDate(targetDate.getDate() +1);        
    else if (flag == 'right-rapid') targetDate.setDate(targetDate.getDate() +7);        

    this.closingDate = targetDate;
  }
  @Watch('closingDate')  
  public onClosingDateChanged(){
    if(this.value) this.loadList();
  }
  
  public onPopupShown(){
    (this.$refs.panel as  HTMLElement).focus();
    (this.$refs.panel as  HTMLElement).addEventListener('focusout', this.closePopup);
  }  

  public closePopup(e:any){
      if(e.relatedTarget && (e.relatedTarget as HTMLElement).className.indexOf('bs-popover-bottom')>0)
      {
          //ヘッダ部分をクリックされた場合はフォーカスバックする
          (e.target as HTMLElement).focus();
      } else if(e.relatedTarget != null && (this.target as  HTMLElement).contains(e.relatedTarget as HTMLElement)){
          //閉じてすぐ開く挙動を回避するため、親ボタン側でクローズさせる
      } else if(e.relatedTarget == null || (this.$refs.panel as  HTMLElement).contains(e.relatedTarget as HTMLElement) == false){
          //v-modelを更新する
          this.$emit('input',false);          
      }
  }
  public openLink(flag:string){
    let routeData = this.$router.resolve(this.getRoute(flag)) ;
    window.open(routeData.href, '_blank');        
  }
  public getLink(index:number,flag:string){
    if(index != this.items.length -1) return null;
    else return this.getRoute(flag);
  }  
  public getRoute(flag:string){
    var code = this.commodity.code;
    var skuCode =  this.sku ? this.sku.code : '';
    var closingDate = this.$api.formatter.formatDateTime(this.closingDate,'YYYY/MM/DD');
    var beginDate = this.$api.formatter.formatDateTime(this.closingDate.getBeginDate(),'YYYY/MM/DD');
    var endDate = this.closingDate.getBeginDate();
    endDate.setMonth(endDate.getMonth() +1);
    endDate.setDate(-1);
    var stockClosingDate =this.$api.formatter.formatDateTime(endDate,'YYYY/MM/DD');

    if (flag == 'stock') {
          return String.format('/journal/StockBalance?commodityCode={0}&skuCode={1}&closingDate={2}', code,skuCode,stockClosingDate);   
    } else if (flag == 'salesOrder') {
          return String.format('/sales/SalesOrderItem?commodityCode={0}&skuCode={1}&state={2}&scheduledDeliveryDateTo={3}', code,skuCode, Common.OrderItemStatus.SalesOrderOpen,closingDate);   
    } else if (flag == 'salesDelivery') {
          return String.format('/sales/SalesDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}', code,skuCode,Common.StockBalanceJournalStatus.SalesDeliveryItem,closingDate);      
    } else if (flag == 'salesDelivered') {
          return String.format('/sales/SalesDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}&deliveryDateFrom={4}', code,skuCode,Common.StockBalanceJournalStatus.SalesDeliveryInvoiceItem,closingDate,beginDate);                   
    } else if (flag == 'purchaseOrder') {
          return String.format('/purchase/PurchaseOrderItem?commodityCode={0}&skuCode={1}&state={2}&scheduledDeliveryDateTo={3}', code,skuCode, Common.OrderItemStatus.PurchaseOrderOpen,closingDate);           
    } else if (flag == 'purchaseDelivery') {
          return String.format('/purchase/PurchaseDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}', code,skuCode,Common.StockBalanceJournalStatus.PurchaseDeliveryNotCompleted,closingDate);         
    } else if (flag == 'purchaseDelivered') {
          return String.format('/purchase/PurchaseDeliveryItem?commodityCode={0}&skuCode={1}&state={2}&deliveryDateTo={3}&deliveryDateFrom={4}', code,skuCode,Common.StockBalanceJournalStatus.PurchasePostCompleted,closingDate,beginDate);               
    }
  }    
}
